import { render, staticRenderFns } from "./AccessLock.vue?vue&type=template&id=33e1bbb3&scoped=true&lang=pug"
import script from "./AccessLock.vue?vue&type=script&lang=js"
export * from "./AccessLock.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33e1bbb3",
  null
  
)

export default component.exports